import useMediaQuery from './useMediaQuery';

export default function useIsScreen2XSAndUp() {
  return useMediaQuery('(min-width: calc(600em / 16))');
}

